module.exports = __webpack_public_path__ + "img/bg0_icon.9b89db3e.jpg";